import * as DOMPurify from 'dompurify';
import * as React from 'react';

import { AccountTag } from 'core/account';

import './searchResult.less';

export interface ISearchResultProps {
  account?: string;
  displayName: string;
}

export class SearchResult extends React.Component<ISearchResultProps> {
  public render() {
    const { displayName, account } = this.props;

    return (
      <span className="search-result">
        {account && <AccountTag account={account} />}
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(displayName) }}/>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/search/infrastructure/SearchResult.tsx